<template>
  <div class="wrapper autocomplete">
    <div class="input-group">
      <input type="text" class="form-control"
        :id="iid !== '' ? iid : ''" :placeholder="placeholder"
        v-model="search"
        @input="onChange"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"/>
      <div v-if="link.title" class="input-group-append">
        <button @click="openLink" class="btn btn-secondary">{{ link.title }}</button>
      </div>
    </div>
      <ul v-show="isOpen" class="list-group autocomplete-results">
        <li class="list-group-item d-flex justify-content-between" v-if="isLoading">
          <span>Lade...</span>
          <font-awesome-icon icon="spinner" spin/>
        </li>
        <li v-for="(result, i) in results" :key="i" class="autocomplete-result list-group-item" :class="{ 'is-active': i === arrowCounter }">
          <div class="wrapper d-flex" @click="setResult(result)">
            <slot name="listitem" :result="result">
              {{ result.value }}
            </slot>
          </div>
        </li>
      </ul>
  </div>
</template>

<script>
export default {
  name: 'AutoCompleter',
  props: {
    iid: { type: String,required: false, default: '' },
    minlen: { type: Number, required: false, default: 2 },
    placeholder: { type: String, required: false, default: ''},
    results: { type: Array, required: true }
  },
  watch: {
    results() {
      this.isLoading = false;
    }
  },
  data() {
    return {
      arrowCounter: -1,
      isOpen: false,
      isLoading: false,
      search: '',
      link: {},
    }
  },
  mounted() {
    console.log(this.placeholder);
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    onChange() {
      console.log('check update: ' + this.search);
      console.log(this.link);
      this.link = {};
      if (!this.isLoading && this.search.length > this.minlen) {
        this.isLoading = true;
        this.isOpen = true;
        this.$emit('reload',this.search);
      }
      if (this.results.length > 0) {
        this.isOpen = true;
      } else if (this.search.length < this.minlen) {
        this.isOpen = false;
      }
    },
    setResult(result) {
      this.$emit('selected',result);
    },
    updateValue(val,link) {
      this.search = val;
      this.isOpen = false;
      this.arrowCounter = -1;
      this.link = link;
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter -1;
      }
    },
    onEnter() {
      this.setResult(this.results[this.arrowCounter]);
      this.isOpen = false;
      this.arrowCounter = -1;
    },
    openLink() {
      this.$emit('openlink');
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    }
  }
}
</script>

<style>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  height: 200px;
  overflow: auto;
  width: 100%;
  position:absolute;
  z-index: 1000;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #4AAE9B;
  color: white;
}

</style>
